import { RouterView } from 'vue-router'

const moduleRoute = {
  path: "/payroll",
  name: "payroll",
  meta: {
    breadcrumb: {
      label: 'Payroll'
    },
    module: "payroll",
    requiresAuth: true,
    title: "Razayya Financial | Insights | Payroll"
  },
  redirect: '/payroll/pay-runs',
  component: () => import(/* webpackChunkName: "payroll" */ "./payrollModule.vue"),
  children: [
    // {
    //   path: "dashboard",
    //   name: "payroll.dashboard",
    //   meta: { 
    //     showInNav: true,
    //     permissions: ["Global.Read", "Payroll.Read"],
    //     breadcrumb: {
    //       label: 'Dashboard',
    //       parent:'payroll'
    //     },
    //     icon: 'mdi-view-dashboard'
    //   },
    //   component: () => import (/* webpackChunkName: "stores" */ "./views/DashboardView.vue"),
    // },
    {
      path: "stores",
      name: "payroll.stores",
      meta: { 
        showInNav: true,
        permissions: ["Global.Read","Store.Read"],
        breadcrumb: {
          label: 'Stores',
          parent:'payroll'
        },
        icon: 'mdi-store'
      },
      component: () => import (/* webpackChunkName: "stores" */ "./views/StoresListView.vue"),
    },
    {
      path: "stores/:id",
      name: "payroll.store-detail",
      meta: { breadcrumb: 
        {
          label: 'Store Details',
          parent: 'payroll.stores'
        } 
      },
      component: () => import (/* webpackChunkName: "store-details" */ "./views/StoreDetailView.vue"),
    },
    {
      path: "employees",
      name: "payroll.employees",
      meta: { 
        showInNav: true,
        permissions: ["Global.Read", "Employee.Read"],
        breadcrumb: 
        {
          label: 'Employees',
          parent:'payroll'
        },
        icon: 'mdi-account-group'
      },
      component: () => import (/* webpackChunkName: "employees" */ "./views/EmployeeListView.vue")
    },
    {
      path: "employees/:employeeId",
      name: 'payroll.employee-detail',
      meta: {
        breadcrumb:{
          label: 'Employee Details',
          parent: 'payroll.employees'
        }
      },
      component: () => import(/* webpackChunkName: "employee-details" */ "./views/EmployeeDetailView.vue")
    },
    {
      path: "pay-runs",
      name: "payroll.pay-runs",
      meta: { 
        showInNav: true,
        breadcrumb: 
        {
          label: 'Pay Runs',
          parent:'payroll'
        },
        icon: 'mdi-cash'
      },
      component: () => import (/* webpackChunkName: "payruns" */ "./views/PayRunsListView.vue")
    },
    {
      path: "pay-runs/:payRunId",
      name: "payroll.pay-runs-detail",
      meta: { breadcrumb: 
        {
          label: 'Pay Run Details',
          parent:'payroll.pay-runs'
        } 
      },
      component: () => import (/* webpackChunkName: "payrun-detail" */ "./views/PayRunDashboardViewV2.vue")
    },
    {
      path: 'pay-runs/:payRunId/employee/:employeeId',
      name: 'payroll.pay-run.employee-detail',
      component: () => import ("./views/EmployeePayRunDetailView.vue"),
      meta: {
        breadcrumb:{
          label:'Employee Payroll Detail',
          parent:'payroll.pay-runs-detail'
        }
      }
    },
    {
      path: 'employee/:employeeId/pay-runs/:payRunId',
      name: 'payroll.employee.pay-run-detail',
      component: () => import ("./views/EmployeePayRunDetailView.vue"),
      meta: {
        breadcrumb:{
          label:'Employee Payroll Detail',
          parent:'payroll.employee-detail'
        }
      }
    },
    {
      path: "metrics",
      name: "payroll.metrics",
      component: RouterView,
      redirect: { name: 'payroll.metrics.dashboard' },
      meta: {
        showInNav: true,
        dynamicChildren: 'hasManualMetrics',
        breadcrumb: {
          label: 'Metrics',
          parent: 'payroll'
        },
        icon: 'mdi-finance'
      },
      children: [
        {
          path: "dashboard",
          name: "payroll.metrics.dashboard",
          component: () => import(/* webpackChunkName: "metrics" */ "./views/MetricsDashboardView.vue"),
          meta: {
            showInNav: true,
            breadcrumb: {
              label: 'Dashboard',
              parent: 'payroll.metrics'
            },
            icon: 'mdi-view-dashboard'
          }
        },
        {
          path: "manual-entry",
          name: "payroll.metrics.manual-entry",
          component: () => import(/* webpackChunkName: "manual-metric-entry" */ "./views/ManualMetricEntryView.vue"),
          meta: {
            showInNav: true,
            permissions: ['Global.Create', 'Global.Update'],
            breadcrumb: {
              label: 'Manual Entry',
              parent: 'payroll.metrics'
            },
            icon: 'mdi-pencil-plus'
          }
        }
      ]
    },
    {
      path: "holidays",
      name: "payroll.holidays",
      component: () => import(/* webpackChunkName: "holidays" */ "./views/HolidaysListView.vue"),
      meta: { 
        showInNav: true,
        permissions: ['Global.Create', 'Global.Update', 'Holiday.Read'],
        breadcrumb: {
          label: 'Holidays',
          parent: 'payroll'
        },
        icon: 'mdi-calendar'
      },
    },
    {
      path: "settings",
      name: "payroll.settings",
      meta: { 
        permissions: ['Global.Create', 'Global.Update'],
        breadcrumb: 
        {
          label: 'Settings',
          parent:'payroll'
        },
        icon: 'mdi-cogs'
      },
      component: () => import (/* webpackChunkName: "settings" */ "./views/SettingsView.vue")
    },
    {
      path: "settings/ratetype/:id",
      name: "payroll.settings.ratetype",
      meta: { breadcrumb: 
        {
          label: 'Rate Type Details',
          parent:'payroll.settings'
        } 
      },
      component: () => import (/* webpackChunkName: "settings" */ "./views/RateTypeDetailView.vue")
    },
    {
      path: "settings/position/:id",
      name: "payroll.settings.position",
      meta: { breadcrumb:
        {
          label: 'Position Details',
          parent:'payroll.settings'
        }
      },
      component: () => import (/* webpackChunkName: "settings" */ "./views/PositionDetailView_2025_Nov.vue")
    },
    {
      path: "settings/metricview/:id",
      name: "payroll.settings.metricview",
      meta: { breadcrumb:
        {
          label: 'Metric View Details',
          parent:'payroll.settings'
        }
      },
      component: () => import (/* webpackChunkName: "settings" */ "./views/MetricViewDetailView.vue")
    },
    {
      path: "dashboard-config",
      name: "payroll.dashboard-config",
      meta: {
        permissions: ['Global.Update'],
        breadcrumb: {
          label: 'Dashboard Configuration',
          parent: 'payroll'
        }
      },
      component: () => import(/* webpackChunkName: "payroll-dashboard-config" */ "./views/PayrunDashboardConfigView.vue")
    },
    {
      path: "formula-builder/:id",
      name: "payroll.formula-builder",
      meta: {
        permissions: ['Global.Update'],
        breadcrumb: {
          label: 'Flow Editor',
          parent: 'payroll.settings'
        }
      },
      component: () => import(/* webpackChunkName: "formula-builder-flow" */ "./components/formula-builder-flow/FormulaBuilderFlow.vue")
    },
    {
      path: "import-wizard"
      , name: "importWizard"
      , component: () => import (/* webpackChunkName: "stores" */ "./views/EmployeeImportWizard.vue" ),
      meta: {
        breadcrumb:{
          label:'Import Wizard',
          parent:'payroll.employees'
        }
      }
    },
  ]
};

export default router => {
  router.addRoute(moduleRoute)
  return moduleRoute
}
